<button class='ba-btn ba-btn-secondary ba-btn-block ba-btn-icon ba-icon-filter mb-3' type='button' id="btn-filter"
        (click)="toggleDiv()"
        [attr.aria-label]="this.isVisible() ?  ('mailbox.hide-filters' | i18next) :  ('mailbox.show-filters' | i18next)">
    <span>{{ this.isVisible() ? ('mailbox.hide-filters' | i18next) : ('mailbox.show-filters' | i18next) }} </span>
</button>

@if (isVisible()) {
    <div id="filters-id" class="ba-layout-tile">
        <h2 class="h5 mt-n1 mb-0" id="heading-behoerde-id">
            {{ 'mailbox.authority' | i18next }}
        </h2>

        <hr class="mx-0" aria-hidden="true"/>

        <fieldset class="ba-input-group" aria-labelledby="legend-behoerde-id">
            <legend id="legend-behoerde-id" class="sr-only">
                {{ 'mailbox.authority' | i18next }}
            </legend>

            <div class="ba-check-group">
                <div class="form-check">
                    <input
                            id="toggle-aa-id"
                            type="checkbox"
                            class="form-check-input"
                            [formControl]="aaChecked"
                            (change)="onCheckboxChange('aa')"
                    />
                    <label for="toggle-aa-id">{{ 'mailbox.employment-agency' | i18next }}</label>
                </div>

                <div class="form-check">
                    <input
                            id="toggle-jc-id"
                            type="checkbox"
                            class="form-check-input"
                            [formControl]="jcChecked"
                            (change)="onCheckboxChange('jc')"
                    />
                    <label for="toggle-jc-id">{{ 'mailbox.jobcenter' | i18next }}</label>
                </div>
            </div>
        </fieldset>
    </div>
}